<template>
  <v-container>
    <v-layout pa-3 mb-2 justify-center row wrap>
      <v-flex xs12 md4>
        <v-flex xs12>
          <amplify-authenticator v-bind:authConfig="authConfig"></amplify-authenticator>
        </v-flex>
       </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      authConfig: {
        signUpConfig: {
          header: 'Create your MCTC Account',
          signUpFields: [
            {
              label: 'Email Address',
              key: 'username',
              required: true,
              displayOrder: 1,
              type: 'text'
            },
            {
              label: 'Password - At least 8 characters (letters & numbers)',
              key: 'password',
              required: true,
              displayOrder: 2,
              type: 'password'
            },
            {
              label: 'Given Name',
              key: 'given_name',
              required: true,
              displayOrder: 3,
              type: 'text'
            },
            {
              label: 'Family Name',
              key: 'family_name',
              required: true,
              displayOrder: 4,
              type: 'text'
            }
          ],
          defaultCountryCode: '61',
          hiddenDefaults: [
            'email'
          ]
        },
        signInConfig: {
          header: 'Sign Into Your MCTC Account'
        }
      }
    }
  }
}
</script>
